import { useState, useEffect, useRef } from "react";
import { baseUrl } from "../../config";
import moment from 'moment';
import axios from "axios";
import { Row, Col, Button, Image, Space, Avatar, Upload, message, notification, InputNumber, Form, Input, Select, Checkbox, DatePicker, Collapse, Tabs, Descriptions, Divider, AutoComplete, Switch, Popconfirm, Alert, Modal, Spin } from "antd";
import '../../assets/styles/custom_style.css';
import {
  UploadOutlined, UserOutlined, DeleteOutlined, FacebookOutlined, InstagramOutlined, TwitterOutlined, PhoneOutlined, MailOutlined, CalendarOutlined, HomeOutlined, SaveOutlined, CheckCircleOutlined, ExclamationCircleOutlined
} from "@ant-design/icons";
import _ from 'lodash';
import PdfImage from "../../assets/images/document.png";
import OccupationDetails from "./OccupationDetails";
import FamilyDetails from "./FamilyDetails";
import SocialStatus from "./SocialStatus";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import DocImage from "../../assets/images/docs.png";
import XlsxImage from "../../assets/images/xlsx.png";


const { Item } = Form;
const { Option } = Select;
const { TabPane } = Tabs;

const AddUserDetailsModel = ({ userData = {}, userBasicDetail, primaryId = '', onIdChange, mode = 'view', isNewMember = false, onDrawerClose }) => {

  const [form] = Form.useForm();
  const cropperRef = useRef(null);
  const [userCheckId, setUserCheckId] = useState(userData?.userid ? userData?.userid : null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [removePhoto, setRemovePhoto] = useState(false);
  const [bussinessFile, setBussinessFile] = useState(null);
  const [userId, setUserId] = useState(null);
  const [saving, setSaving] = useState(false);

  const [imageURL, setImageURL] = useState(false);
  const [bussinessURL, setBussinessURL] = useState(false);
  const [bussinessImageUrl, setBussinessImageUrl] = useState(false);
  const [, setLoading] = useState(false);

  const [villageOptions, setVillageOptions] = useState([]);
  const [villageSearching, setVillageSearching] = useState(false);
  const villageTimerRef = useRef(null);
  const villageJustSelectedRef = useRef(false);
  const [refSource, setRefSource] = useState(null);
  const [refMemberOptions, setRefMemberOptions] = useState([]);
  const [refMemberSearching, setRefMemberSearching] = useState(false);

  const searchVillage = (q) => {
    clearTimeout(villageTimerRef.current);
    if (!q || q.length < 1) { setVillageOptions([]); setVillageSearching(false); return; }
    setVillageSearching(true);
    villageTimerRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${baseUrl}/village/search`, {
          params: { q },
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
        setVillageOptions((res.data.result || []).map(v => {
          const parts = [v.name_en]; if (v.name_hn) parts.push(v.name_hn);
          const loc = [v.tehsil_en, v.district_en].filter(Boolean).join(', ');
          return { value: v.name_en, label: loc ? `${parts.join(' / ')} — ${loc}` : parts.join(' / '), data: v };
        }));
      } catch { setVillageOptions([]); }
      finally { setVillageSearching(false); }
    }, 300);
  };

  const handleVillageSelect = (_, option) => {
    villageJustSelectedRef.current = true;
    const v = option.data;
    setPermanentAddress(prev => ({
      ...prev,
      per_village_id: v.id,
      per_village_en: v.name_en    || prev.per_village_en,
      per_village_hn: v.name_hn    || prev.per_village_hn,
      per_post_en:    v.post_en    || prev.per_post_en,
      per_post_hn:    v.post_hn    || prev.per_post_hn,
      per_tahsil_en:  v.tehsil_en  || prev.per_tahsil_en,
      per_tahsil_hn:  v.tehsil_hn  || prev.per_tahsil_hn,
      per_pin_code_en: v.pincode_en || prev.per_pin_code_en,
      per_pin_code_hn: v.pincode_hn || prev.per_pin_code_hn,
      per_district_en: v.district_en || prev.per_district_en,
      per_district_hn: v.district_hn || prev.per_district_hn,
      per_state_en:   v.state_en   || prev.per_state_en,
      per_state_hn:   v.state_hn   || prev.per_state_hn,
    }));
  };

  const searchRefMember = async (q) => {
    if (!q || q.length < 2) { setRefMemberOptions([]); return; }
    setRefMemberSearching(true);
    try {
      const res = await axios.get(`${baseUrl}/users/search-member`, {
        params: { q },
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      });
      setRefMemberOptions((res.data.result || []).map(m => ({
        value: String(m.id),
        label: `${m.name} (${m.phone_no})`
      })));
    } catch { setRefMemberOptions([]); }
    finally { setRefMemberSearching(false); }
  };

  const [showPermanentAddress, setShowPermanentAddress] = useState(false);
  const [showTemporaryAddress, setShowTemporaryAddress] = useState(false);
  const [showSocialLink, setShowSocialLink] = useState(false);
  const [showUloadFile, setshowUloadFile] = useState(false);
  const [multiDocument, setMultiDocument] = useState([])
  const [fileList, setFileList] = useState([]);
  const [sameAsPermanent, setSameAsPermanent] = useState(false);

  const [editorOpen, setEditorOpen] = useState(false);
  const [preview, setPreview] = useState(null);

  const [dobDate, setDobDate] = useState();
  // Anniversary: date, a newly picked image + preview, and whether the saved image should be removed
  const [annivDate, setAnnivDate] = useState(null);
  const [annivFile, setAnnivFile] = useState(null);
  const [annivPreview, setAnnivPreview] = useState(null);
  const [removeAnnivImg, setRemoveAnnivImg] = useState(false);
  const [permanentAddress, setPermanentAddress] = useState({
    per_village_id: null,
    per_address_en: "",
    per_village_en: "",
    per_post_en: "",
    per_tahsil_en: "",
    per_pin_code_en: "",
    per_district_en: "",
    per_state_en: "",
    per_country_en: "",
    per_address_hn: "",
    per_village_hn: "",
    per_post_hn: "",
    per_tahsil_hn: "",
    per_pin_code_hn: "",
    per_district_hn: "",
    per_state_hn: "",
    per_country_hn: ""
  });

  const [temporaryAddress, setTemporaryAddress] = useState({
    tem_address_en: "",
    tem_street_en: "",
    tem_city_en: "",
    tem_pin_code_en: "",
    tem_district_en: "",
    tem_state_en: "",
    tem_country_en: "",
    tem_address_hn: "",
    tem_street_hn: "",
    tem_city_hn: "",
    tem_pin_code_hn: "",
    tem_district_hn: "",
    tem_state_hn: "",
    tem_country_hn: ""
  });

  const [socialMediaLinks, setSocialMediaLinks] = useState({
    facebook_url: "",
    instagram_url: "",
    twitter_url: ""
  });

  useEffect(() => {
    console.log("Mode:", mode, "isNewMember:", isNewMember);
    setUserCheckId(userData?.userid ? userData?.userid : null);
  }, [userData?.userid, mode, isNewMember]);

  const handleButtonChildrenChange = (id) => {
    if (primaryId) {
      onIdChange(id);
    }
  };

  const handlePermanentAddressCheckboxChange = (e) => {
    setShowPermanentAddress(e.target.checked);
  };

  const handleTemporaryAddressCheckboxChange = (e) => {
    setShowTemporaryAddress(e.target.checked);
  };

  const handleSocialLinkCheckboxChange = (e) => {
    setShowSocialLink(e.target.checked);
  };

  const handleUploadFileCheckboxChange = (e) => {
    setshowUloadFile(e.target.checked);
  };

  const handleBussinessImageChange = (e) => {
    const file = e.target.files[0];
    console.log("file", file);
    setBussinessFile(file);
    const reader = new FileReader();
    reader.onload = (event) => {
      console.log("event.target.result", event.target.result);
      setBussinessImageUrl(event.target.result);
    };
    reader.readAsDataURL(file);
    message.info(`Selected file: ${file.name}`);
  };

  const handleBussinessButtonClick = () => {
    const fileInput = document.getElementById('fileBussinessInput');
    fileInput.click();
  };

  useEffect(() => {
    // Handle existing user data
    if (userData && Object.keys(userData).length > 0) {
      setIsUpdateMode(true);
      setImageURL(userData.profile_img)
      setBussinessURL(userData.occ_bussiness_img)
      setPermanentAddress({
        per_village_id: userData.per_village_id || null,
        per_address_en: userData.per_address_en || "",
        per_village_en: userData.per_village_en || "",
        per_post_en: userData.per_post_en || "",
        per_tahsil_en: userData.per_tahsil_en || "",
        per_pin_code_en: userData.per_pin_code_en || "",
        per_district_en: userData.per_district_en || "",
        per_state_en: userData.per_state_en || 'Rajasthan',
        per_country_en: userData.per_country_en || 'India',
        per_address_hn: userData.per_address_hn || "",
        per_village_hn: userData.per_village_hn || "",
        per_post_hn: userData.per_post_hn || "",
        per_tahsil_hn: userData.per_tahsil_hn || "",
        per_pin_code_hn: userData.per_pin_code_hn || "",
        per_district_hn: userData.per_district_hn || "",
        per_state_hn: userData.per_state_hn || 'राजस्थान',
        per_country_hn: userData.per_country_hn || 'भारत'
      });
      setMultiDocument(userData?.uploadDocuments ? JSON.parse(userData?.uploadDocuments) : [])
      
      setTemporaryAddress({
        tem_address_en: userData.tem_address_en || "",
        tem_street_en: userData.tem_street_en || "",
        tem_city_en: userData.tem_city_en || "",
        tem_pin_code_en: userData.tem_pin_code_en || "",
        tem_district_en: userData.tem_district_en || "",
        tem_state_en: userData.tem_state_en || "",
        tem_country_en: userData.tem_country_en || "",
        tem_address_hn: userData.tem_address_hn || "",
        tem_street_hn: userData.tem_street_hn || "",
        tem_city_hn: userData.tem_city_hn || "",
        tem_pin_code_hn: userData.tem_pin_code_hn || "",
        tem_district_hn: userData.tem_district_hn || "",
        tem_state_hn: userData.tem_state_hn || "",
        tem_country_hn: userData.tem_country_hn || ""
      });

      setSocialMediaLinks({
        facebook_url: userData.facebook_url || "",
        instagram_url: userData.instagram_url || "",
        twitter_url: userData.twitter_url || ""
      });

      const formattedUserData = { ...userData };
      setDobDate(userData.dob ? userData.dob : null);
      setAnnivDate(userData.anniversary_date || null);
      setAnnivPreview(userData.anniversary_img || null);
      setAnnivFile(null);
      setRemoveAnnivImg(false);
      const userId = userData.userid;
      setUserId(userId);
      setRefSource(userData.ref_source || null);
      form.setFieldsValue({ ...formattedUserData, ref_member_id: undefined });
      if (userData.ref_member_id) {
        // Fetch referrer name fresh from API — reliable regardless of JOIN issues
        axios.get(`${baseUrl}/users/member-info/${userData.ref_member_id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        }).then(res => {
          if (res.data.status && res.data.result) {
            const { name, phone_no } = res.data.result;
            const label = `${name} (${phone_no})`;
            const opt = { value: String(userData.ref_member_id), label };
            setRefMemberOptions([opt]);
            form.setFieldsValue({ ref_member_id: { value: String(userData.ref_member_id), label } });
          }
        }).catch(() => {});
      }
    } 
    // Handle new member creation
    else if (userBasicDetail && Object.keys(userBasicDetail).length > 0) {
      setIsUpdateMode(false);
      setAnnivDate(null);
      setAnnivPreview(null);
      setAnnivFile(null);
      setRemoveAnnivImg(false);
      
      // Initialize form with basic details and defaults
      const initialValues = {
        ...userBasicDetail,
        caste: 'Rajpurohit',
        per_state_en: 'Rajasthan',
        per_state_hn: 'राजस्थान',
        per_country_en: 'India',
        per_country_hn: 'भारत',
        status: 'Active',
        email_address: '',
        alternate_phone_no: '',
        alternate_phone_no2: '',
        gotra: '',
        kuldevi: '',
        kulrishi: '',
        remark: '',
        pan_number: '',
        aadhar_no: '',
        maritial_status: '',
        ref_source: undefined,
        ref_member_id: undefined,
        ref_note: ''
      };

      form.setFieldsValue(initialValues);
      setImageURL(null)
      setBussinessURL(null)
      
      // Set default addresses
      setPermanentAddress({
        per_address_en: userBasicDetail.per_address_en || "",
        per_village_en: userBasicDetail.per_village_en || "",
        per_post_en: "",
        per_tahsil_en: userBasicDetail.per_tahsil_en || "",
        per_pin_code_en: "",
        per_district_en: userBasicDetail.per_district_en || "",
        per_state_en: "Rajasthan",
        per_country_en: "India",
        per_address_hn: userBasicDetail.per_address_hn || "",
        per_village_hn: userBasicDetail.per_village_hn || "",
        per_post_hn: "",
        per_tahsil_hn: userBasicDetail.per_tahsil_hn || "",
        per_pin_code_hn: "",
        per_district_hn: userBasicDetail.per_district_hn || "",
        per_state_hn: "राजस्थान",
        per_country_hn: "भारत"
      });

      setTemporaryAddress({
        tem_address_en: "",
        tem_street_en: "",
        tem_city_en: "",
        tem_pin_code_en: "",
        tem_district_en: "",
        tem_state_en: "Rajasthan",
        tem_country_en: "India",
        tem_address_hn: "",
        tem_street_hn: "",
        tem_city_hn: "",
        tem_pin_code_hn: "",
        tem_district_hn: "",
        tem_state_hn: "राजस्थान",
        tem_country_hn: "भारत"
      });

      setSocialMediaLinks({
        facebook_url: "",
        instagram_url: "",
        twitter_url: ""
      });
    }

    setUserCheckId(userData?.userid || userData?.user_id || null)

  }, [userData, userBasicDetail, form, mode]);

  const onFinish = async (values) => {
    setSaving(true);
    try {
      // Validate required fields for new members
      if (!isUpdateMode) {
        const requiredFields = ['name_eng'];
        const missingFields = requiredFields.filter(field => !values[field]);
        
        if (missingFields.length > 0) {
          notification.error({
            message: 'Validation Error',
            description: 'Please fill all required fields: Name',
            placement: 'topRight'
          });
          setSaving(false);
          return;
        }
      }

      const formData = new FormData();
      Object.keys(values).forEach(key => {
        const val = key === 'ref_member_id' && values[key]?.value !== undefined
          ? values[key].value
          : values[key];
        formData.append(key, val != null ? val : '');
      });

      // Basic Details
      if (userBasicDetail) {
        formData.append("country_code", userBasicDetail.country_code ? userBasicDetail.country_code : '');
      }

      if (primaryId) {
        formData.append("primaryId", primaryId);
      }

      if (dobDate) {
        const formattedDate = moment(dobDate).format('YYYY-MM-DD');
        formData.append("dob", formattedDate);
      }

      if (annivDate) {
        formData.append("anniversary_date", moment(annivDate).format('YYYY-MM-DD'));
      }
      if (annivFile) {
        formData.append("anniversary_img", annivFile);
      } else if (removeAnnivImg) {
        formData.append("remove_anniversary_img", "true");
      }

      // Address data
      for (const key in permanentAddress) {
        if (permanentAddress[key]) {
          formData.append(key, permanentAddress[key]);
        }
      }

      for (const key in temporaryAddress) {
        if (temporaryAddress[key]) {
          formData.append(key, temporaryAddress[key]);
        }
      }

      for (const key in socialMediaLinks) {
        if (socialMediaLinks[key]) {
          formData.append(key, socialMediaLinks[key]);
        }
      }

      if (file) {
        formData.append("file", file);
      } else if (removePhoto) {
        formData.append("remove_profile_img", "true");
      }

      if (bussinessFile) {
        formData.append("document", bussinessFile);
      }

      if (fileList.length > 0) {
        fileList.forEach(file => {
          const blob = new Blob([file.binary], { type: file.type });
          formData.append('multiFiles', blob, file.name);
        });
      }

      let response;
      let successMessage;

      if (isUpdateMode) {
        response = await axios.patch(`${baseUrl}/users/update/${userId}`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
        successMessage = 'Member updated successfully!';
      } else {
        response = await axios.post(`${baseUrl}/users/create`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
        successMessage = 'New member created successfully!';
      }

      if (response.status === 200) {
        notification.success({
          message: 'Success',
          description: successMessage,
          placement: 'topRight',
          duration: 3
        });

        if (!isUpdateMode) {
          // New member created - update parent component
          const newUserId = response.data.data.user.id;
          const newUserData = {
            ...values,
            ...userBasicDetail,
            user_id: newUserId,
            profile_img: response.data.data.user.profile_img
          };
          
          setUserId(newUserId);
          setUserCheckId(newUserId);
          setIsUpdateMode(true);
          
          // Call the parent's onIdChange with new user data
          if (onIdChange) {
            onIdChange(newUserId, newUserData);
          }
        }

        // Auto-close the drawer after successful save
        if (onDrawerClose) {
          setTimeout(() => onDrawerClose(), 1000);
        }

      } else {
        notification.error({
          message: 'Error',
          description: response.data.message || 'Failed to save member details',
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: error.response?.data?.message || 'An error occurred while saving member details',
        placement: 'topRight'
      });
    } finally {
      setSaving(false);
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const beforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setFileList(prevState => [...prevState, { name: file.name, binary: e.target.result, type: file.type }]);
    };
    reader.readAsArrayBuffer(file);
    return false;
  };

  // Function to handle input change for permanent address fields
  const handlePermanentAddressChange = (fieldName, value, columnHindi, isHindi) => {
    if (isHindi) {
      setPermanentAddress({
        ...permanentAddress,
        [fieldName]: value
      });
      debounceConvertTextAddress(value, columnHindi, 'permanent');
    } else {
      if (columnHindi) {
        setPermanentAddress({
          ...permanentAddress,
          [fieldName]: value,
          [columnHindi]: value
        });
      } else {
        setPermanentAddress({
          ...permanentAddress,
          [fieldName]: value
        });
      }
    }
  };

  // Function to handle input change for temporary address fields
  const handleTemporaryAddressChange = (fieldName, value, columnHindi, isHindi) => {
    if (isHindi) {
      setTemporaryAddress({
        ...temporaryAddress,
        [fieldName]: value
      });
      debounceConvertTextAddress(value, columnHindi, 'temporary');
    } else {
      if (columnHindi) {
        setTemporaryAddress({
          ...temporaryAddress,
          [fieldName]: value,
          [columnHindi]: value
        });
      } else {
        setTemporaryAddress({
          ...temporaryAddress,
          [fieldName]: value
        });
      }
    }
  };

  // Function to handle input change for social media fields
  const handleSocialMediaChange = (fieldName, value) => {
    setSocialMediaLinks({
      ...socialMediaLinks,
      [fieldName]: value
    });
  };

  const handleSameAsPermanentChange = () => {
    if (!sameAsPermanent) {
      setTemporaryAddress({
        ...temporaryAddress,
        tem_address_en: permanentAddress.per_address_en,
        tem_street_en: permanentAddress.per_village_en,
        tem_city_en: permanentAddress.per_post_en,
        tem_pin_code_en: permanentAddress.per_pin_code_en,
        tem_district_en: permanentAddress.per_district_en,
        tem_state_en: permanentAddress.per_state_en,
        tem_country_en: permanentAddress.per_country_en,
        tem_address_hn: permanentAddress.per_address_hn,
        tem_street_hn: permanentAddress.per_village_hn,
        tem_city_hn: permanentAddress.per_post_hn,
        tem_pin_code_hn: permanentAddress.per_pin_code_hn,
        tem_district_hn: permanentAddress.per_district_hn,
        tem_state_hn: permanentAddress.per_state_hn,
        tem_country_hn: permanentAddress.per_country_hn
      });
    } else {
      if (userData) {
        setTemporaryAddress({
          tem_address_en: userData.tem_address_en || "",
          tem_street_en: userData.tem_street_en || "",
          tem_city_en: userData.tem_city_en || "",
          tem_pin_code_en: userData.tem_pin_code_en || "",
          tem_district_en: userData.tem_district_en || "",
          tem_state_en: userData.tem_state_en || "",
          tem_country_en: userData.tem_country_en || "",
          tem_address_hn: userData.tem_address_hn || "",
          tem_street_hn: userData.tem_street_hn || "",
          tem_city_hn: userData.tem_city_hn || "",
          tem_pin_code_hn: userData.tem_pin_code_hn || "",
          tem_district_hn: userData.tem_district_hn || "",
          tem_state_hn: userData.tem_state_hn || 'राजस्थान',
          tem_country_hn: userData.tem_country_hn || ""
        });
      }
    }
    setSameAsPermanent(!sameAsPermanent);
  };

  const debounceConvertText = useRef(_.debounce(async (text, column) => {
    try {
      const response = await axios.post(`${baseUrl}/translate`, { text });
      form.setFieldsValue({
        [column]: response.data.translatedText,
      });
    } catch (error) {
      console.error('Error translating text:', error);
    }
  }, 300)).current;

  const debounceConvertTextAddress = useRef(_.debounce(async (text, column, addressType) => {
    try {
      const response = await axios.post(`${baseUrl}/translate`, { text });
      if (addressType === 'permanent') {
        setPermanentAddress(prevState => ({
          ...prevState,
          [column]: response.data.translatedText,
        }));
      } else {
        setTemporaryAddress(prevState => ({
          ...prevState,
          [column]: response.data.translatedText,
        }));
      }
    } catch (error) {
      console.error('Error translating text:', error);
    }
  }, 300)).current;

  function handleInputChange(text, column) {
    const newText = text;
    debounceConvertText(newText, column);
  };

  const [optionSuggestion, setOptionSuggestion] = useState([]);

  const getPanelValue = async (searchText, columnName, tableName) => {
    if (searchText.length < 3) {
      setOptionSuggestion([]);
      return;
    }

    try {
      const response = await axios.get(`${baseUrl}/payments/getSuggestionValue/`, {
        params: { q: searchText, column: columnName, table: tableName },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        setOptionSuggestion(response.data.result);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleChangeSuggestion = (value, columnName) => {
    setPermanentAddress((prevAddress) => ({
      ...prevAddress,
      [columnName]: value
    }));
  };

  const handleChangeSuggestionTemp = (value, columnName) => {
    setTemporaryAddress((prevAddress) => ({
      ...prevAddress,
      [columnName]: value
    }));
  };

  const handleUpperCaseChange = (fieldName, e) => {
    const value = e.target.value;
    const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
    form.setFieldsValue({
      [fieldName]: capitalizedValue
    });
  };

  const [selectedAddressSection, setSelectedAddressSection] = useState('permanentAddress');

  const handleAddressCheckboxChange = (formType) => {
    setSelectedAddressSection(selectedAddressSection === formType ? null : formType);
  };

  // Mapping between English and Hindi values
  const relationMapping = {
    "Son of Mr.": "सुपुत्र श्री",
    "Daughter of Mr.": "सुपुत्री श्री",
    "Wife of Mr.": "पत्नी श्री",
    "Adopted Son of Mr.": "गोद पुत्र श्री",
    "Disciple of Mr.": "शिष्य श्री"
  };

  // Function to handle change
  const handleRelationChange = (value) => {
    const hindiValue = relationMapping[value];
    form.setFieldsValue({
      relation_en: value,
      relation_hn: hindiValue
    });
  };

  const handleDateChange = (date, dateString) => {
    if (date) {
      const formattedDate = moment(date).format('YYYY-MM-DD');
      setDobDate(formattedDate)
    } else {
      setDobDate(null);
    }
  };

  const handleAnnivImageSelect = (e) => {
    const picked = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!picked) return;
    if (!picked.type.startsWith('image/')) {
      message.error('Please select an image file');
      return;
    }
    if (picked.size > 5 * 1024 * 1024) {
      message.error('Anniversary image must be smaller than 5MB');
      return;
    }
    setAnnivFile(picked);
    setAnnivPreview(URL.createObjectURL(picked));
    setRemoveAnnivImg(false);
  };

  const handleAnnivImageRemove = () => {
    setAnnivFile(null);
    setAnnivPreview(null);
    setRemoveAnnivImg(Boolean(userData?.anniversary_img));
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setFile(file);
      setImageUrl(URL.createObjectURL(file));
      setRemovePhoto(false);
      setEditorOpen(true);
    }
  };

  const handleButtonClick = () => {
    document.getElementById('fileInput').click();
  };

  const handleRemovePhoto = () => {
    setImageUrl(null);
    setImageURL(null);
    setFile(null);
    setRemovePhoto(true);
  };

  const onCrop = (preview) => {
    setPreview(preview);
  };

  const onClose = () => {
    setEditorOpen(false);
  };

  const saveCroppedImage = () => {
    const cropper = cropperRef.current.cropper;
    const croppedCanvas = cropper.getCroppedCanvas();
    const croppedImageUrl = croppedCanvas.toDataURL();
    setImageUrl(croppedImageUrl);
    setFile(dataURLtoFile(croppedImageUrl, 'croppedImage.png'));
    setEditorOpen(false);
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const deleteImage = async (id, imagePath) => {
    try {
      const response = await axios.delete(`${baseUrl}/user/delete-document?id=${id}&imagePath=${imagePath}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      });

      if (response.status === 200) {
        notification.success({
          message: 'Success',
          description: 'Image/document deleted successfully!',
          placement: 'topRight'
        });
        const images = multiDocument.filter((doc) => doc !== imagePath);
        setMultiDocument(images)
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error(error);
      throw new Error('Failed to delete image');
    }
  };

  return (
    <>
      <div className="tabled">
        {/* Status Alert */}
        {mode === 'create' && (
          <Alert
            message="Creating New Member"
            description={`You are creating a new member with phone number: ${userBasicDetail?.phone_no}. Please fill all required information.`}
            type="info"
            showIcon
            icon={<ExclamationCircleOutlined />}
            style={{ marginBottom: 10 }}
          />
        )}
        
        {/* {mode === 'edit' && userId && (
          <Alert
            message="Editing Member Details"
            description={`You are editing details for Member ID: ${userId}. Changes will be saved to the existing record.`}
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )} */}

        <Tabs
          defaultActiveKey="1"
          size="small"
          className="compact-tabs"
          tabBarGutter={2}
          tabBarStyle={{
            marginBottom: 0,
            background: '#f0f3f7',
            padding: '2px 8px 0',
            borderRadius: '6px 6px 0 0',
            borderBottom: '2px solid #7a0000',
          }}
        >
          <TabPane tab="Basic Details" key="1">
            <Row gutter={[0, 0]}>
              <Col xs="24" xl={24}>
                  <Form
                    style={{ padding: 0 }}
                    className="add-payment-form"
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                      status: "Active",
                      caste: "Rajpurohit",
                      per_state_en: "Rajasthan",
                      per_state_hn: "राजस्थान",
                      per_country_en: "India",
                      per_country_hn: "भारत",
                      payment_commitment: "recurring"
                    }}
                    layout="vertical"
                  >
                    <Row gutter={[8, 4]}>

                      {/* ── Top section: fields + photo ── */}
                      <Col xs={24}>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>

                          {/* Left: all form fields */}
                          <div style={{ flex: 1, minWidth: 0 }}>

                            {/* Phone */}
                            <Row gutter={[8, 0]}>
                              <Col xs={24} sm={12} lg={6}>
                                <Item label="Phone Number" name="phone_no" rules={[{ required: true, message: 'Please enter phone number' }]}>
                                  <Input placeholder="Enter Phone Number" prefix={<PhoneOutlined />} />
                                </Item>
                              </Col>
                            </Row>

                            {/* Section labels row */}
                            <Row gutter={[8, 0]} style={{ marginTop: 4 }}>
                              <Col xs={24} lg={12}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #f0f0f0' }}>
                                  In English {mode === 'create' && <span style={{ color: 'red', fontSize: 10, marginLeft: 4 }}>*Required</span>}
                                </div>
                              </Col>
                              <Col xs={24} lg={12}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #f0f0f0' }}>
                                  हिंदी में (In Hindi)
                                </div>
                              </Col>
                            </Row>

                            {/* EN + HN fields in one row */}
                            <Row gutter={[8, 0]}>
                              <Col xs={24} sm={12} lg={4}>
                                <Item label={<span>Name {mode === 'create' && <span style={{ color: 'red' }}>*</span>}</span>} name="name_eng" rules={[{ required: true, message: 'Please enter name' }]}>
                                  <Input placeholder="Enter Full Name" onChange={(e) => handleInputChange(e.target.value, 'name_hn')} prefix={<UserOutlined />} />
                                </Item>
                              </Col>
                              <Col xs={24} sm={12} lg={4}>
                                <Item label="Relation" name="relation_en" rules={[]}>
                                  <Select placeholder="Select Relation" onChange={handleRelationChange}>
                                    <Option value="Son of Mr.">Son of Mr.</Option>
                                    <Option value="Daughter of Mr.">Daughter of Mr.</Option>
                                    <Option value="Wife of Mr.">Wife of Mr.</Option>
                                    <Option value="Adopted Son of Mr.">Adopted Son of Mr.</Option>
                                    <Option value="Disciple of Mr.">Disciple of Mr.</Option>
                                  </Select>
                                </Item>
                              </Col>
                              <Col xs={24} sm={12} lg={4}>
                                <Item label="Father/Husband Name" name="father_name_en" rules={[]}>
                                  <Input placeholder="Enter Father/Husband Name" onChange={(e) => handleInputChange(e.target.value, 'father_name_hn')} prefix={<UserOutlined />} />
                                </Item>
                              </Col>
                              <Col xs={24} sm={12} lg={4}>
                                <Item label="नाम" name="name_hn">
                                  <Input placeholder="नाम दर्ज करें" prefix={<UserOutlined />} />
                                </Item>
                              </Col>
                              <Col xs={24} sm={12} lg={4}>
                                <Item label="संबंध" name="relation_hn">
                                  <Select placeholder="संबंध चुनें">
                                    <Option value="सुपुत्र श्री">सुपुत्र श्री</Option>
                                    <Option value="सुपुत्री श्री">सुपुत्री श्री</Option>
                                    <Option value="पत्नी श्री">पत्नी श्री</Option>
                                    <Option value="गोद पुत्र श्री">गोद पुत्र श्री</Option>
                                    <Option value="शिष्य श्री">शिष्य श्री</Option>
                                  </Select>
                                </Item>
                              </Col>
                              <Col xs={24} sm={12} lg={4}>
                                <Item label="पिता/पति का नाम" name="father_name_hn">
                                  <Input placeholder="पिता/पति का नाम दर्ज करें" prefix={<UserOutlined />} />
                                </Item>
                              </Col>
                            </Row>

                          </div>

                          {/* Right: Photo */}
                          <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', width: 110 }}>
                            <input type="file" id="fileInput" style={{ display: 'none' }} onChange={handleImageChange} />
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 8 }}>Photo</div>
                            <Avatar
                              size={90}
                              icon={<UserOutlined />}
                              src={imageUrl ? imageUrl : imageURL}
                              style={{ border: '3px solid #7a0000', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', marginBottom: 8 }}
                            />
                            <Button icon={<UploadOutlined />} onClick={handleButtonClick} type="primary" size="small" style={{ background: '#7a0000', borderColor: '#7a0000', borderRadius: 8, fontSize: 12 }}>
                              {mode === 'create' ? 'Upload' : 'Change'}
                            </Button>
                            {(imageUrl || imageURL) && (
                              <Button danger size="small" onClick={handleRemovePhoto} style={{ marginTop: 4, borderRadius: 8, fontSize: 12, width: '100%' }}>
                                Remove
                              </Button>
                            )}
                            <Modal
                              open={editorOpen}
                              title="Crop Photo"
                              onCancel={onClose}
                              footer={[
                                <Button key="cancel" onClick={onClose} style={{ borderRadius: 8 }}>Cancel</Button>,
                                <Button key="save" type="primary" onClick={saveCroppedImage} icon={<SaveOutlined />} style={{ background: '#7a0000', borderColor: '#7a0000', borderRadius: 8 }}>Save</Button>,
                              ]}
                              width={480}
                              centered
                              destroyOnClose
                            >
                              <Cropper src={imageUrl} style={{ height: 300, width: '100%' }} initialAspectRatio={1} guides={false} ref={cropperRef} />
                            </Modal>
                          </div>

                        </div>
                      </Col>

                      {/* Other Details Section */}
                      <Col xs={24} sm={24} lg={24}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 6, paddingBottom: 4, borderBottom: '1px solid #f0f0f0', marginTop: 6 }}>
                          Other Details
                        </div>
                        <Row gutter={[12, 0]}>
                          <Col xs={24} sm={12} lg={4}>
                            <Item 
                              label="Email Address" 
                              name="email_address"
                              rules={[
                                {
                                  type: 'email',
                                  message: 'The input is not a valid email address!',
                                },
                              ]}
                            >
                              <Input placeholder="Email Address" prefix={<MailOutlined />} />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="DOB">
                              <DatePicker 
                                onChange={handleDateChange} 
                                value={dobDate && moment(dobDate)} 
                                className="filter_dob" 
                                format="DD/MM/YYYY" 
                                placeholder="Select Date of Birth" 
                                prefix={<CalendarOutlined />} 
                              />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item 
                              label="Alt Phone No1" 
                              name="alternate_phone_no" 
                              rules={[
                                {
                                  pattern: /^\d{10,12}$/,
                                  message: 'Phone no must be between 10 and 12 digits!',
                                }
                              ]}
                            >
                              <Input placeholder="Alt Phone No" prefix={<PhoneOutlined />} />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item 
                              label="Alt Phone No2" 
                              name="alternate_phone_no2" 
                              rules={[
                                {
                                  pattern: /^\d{10,12}$/,
                                  message: 'Phone no must be between 10 and 12 digits!',
                                }
                              ]}
                            >
                              <Input placeholder="Alt Phone No2" prefix={<PhoneOutlined />} />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="Marital status" name="maritial_status">
                              <Select placeholder="Marital status">
                                <Option value="Married">Married</Option>
                                <Option value="UnMarried">UnMarried</Option>
                                <Option value="Widowed">Widowed</Option>
                              </Select>
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="Anniversary" tooltip="Marriage anniversary — the anniversary image is sent on WhatsApp on this date every year">
                              <DatePicker
                                onChange={(date) => setAnnivDate(date ? moment(date).format('YYYY-MM-DD') : null)}
                                value={annivDate ? moment(annivDate) : null}
                                className="filter_dob"
                                format="DD/MM/YYYY"
                                placeholder="Anniversary Date"
                                disabledDate={(d) => d && d.isAfter(moment(), 'day')}
                              />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="Anniversary Image">
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, minHeight: 32 }}>
                                {annivPreview ? (
                                  <Image
                                    src={annivPreview}
                                    width={40}
                                    height={40}
                                    style={{ objectFit: 'cover', borderRadius: 6, border: '1px solid #e2e8f0' }}
                                  />
                                ) : (
                                  <div style={{ width: 40, height: 40, borderRadius: 6, border: '1px dashed #cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 18 }}>
                                    💍
                                  </div>
                                )}
                                <Button size="small" icon={<UploadOutlined />} onClick={() => document.getElementById('annivImageInput').click()}>
                                  {annivPreview ? 'Change' : 'Upload'}
                                </Button>
                                {annivPreview && (
                                  <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={handleAnnivImageRemove} />
                                )}
                                <input id="annivImageInput" type="file" accept="image/*" style={{ display: 'none' }} onChange={handleAnnivImageSelect} />
                              </div>
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="Caste" name="caste">
                              <Input 
                                defaultValue="Rajpurohit" 
                                placeholder="Caste Name" 
                                onChange={(e) => handleUpperCaseChange('caste', e)} 
                              />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="Gotra" name="gotra">
                              <Input placeholder="Gotra Name" onChange={(e) => handleUpperCaseChange('gotra', e)} />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="Kuldevi" name="kuldevi">
                              <Input placeholder="Kuldevi Name" onChange={(e) => handleUpperCaseChange('kuldevi', e)} />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="Kulrishi" name="kulrishi">
                              <Input placeholder="Kulrishi name" onChange={(e) => handleUpperCaseChange('kulrishi', e)} />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={4}>
                            <Item label="Status" name="status">
                              <Select placeholder="Status">
                                <Option value="Active">Active</Option>
                                <Option value="Inactive">Inactive</Option>
                              </Select>
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={5}>
                            <Item
                              label={<span>Payment Type <span style={{ color: '#ff4d4f', fontSize: 10 }}>★</span></span>}
                              name="payment_commitment"
                              tooltip="One Time = paid once, no monthly pending shown. Recurring = monthly contributor."
                            >
                              <Select placeholder="Select payment type" defaultValue="recurring">
                                <Option value="recurring">Monthly / मासिक (नियमित)</Option>
                                <Option value="one_time">One Time / एक बार</Option>
                              </Select>
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={6}>
                            <Item label="Remark" name="remark">
                              <Input placeholder="Remark" />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={6}>
                            <Item label="PAN Card Number" name="pan_number">
                              <Input placeholder="PAN Card Number" />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={6}>
                            <Item label="Aadhar No" name="aadhar_no">
                              <Input placeholder="Aadhar No" />
                            </Item>
                          </Col>

                          <Col xs={24} sm={12} lg={6}>
                            <Item label="Category" name="category">
                              <Input placeholder="Category" />
                            </Item>
                          </Col>
                        </Row>

                        {/* ── Referral / Reference ── */}
                        <Row gutter={[8, 0]} style={{ marginTop: 4, background: '#f0f7ff', border: '1px solid #91caff', borderRadius: 8, padding: '8px 4px' }}>
                          <Col xs={24} style={{ marginBottom: 4 }}>
                            <span style={{ fontSize: 12, fontWeight: 700, color: '#1677ff' }}>संदर्भ / रेफरल जानकारी</span>
                          </Col>
                          <Col xs={24} sm={12} lg={6}>
                            <Item label="कैसे जुड़े?" name="ref_source">
                              <Select
                                placeholder="माध्यम चुनें"
                                allowClear
                                onChange={v => { setRefSource(v); if (v !== 'member') form.setFieldsValue({ ref_member_id: undefined }); }}
                              >
                                <Option value="member">सदस्य के माध्यम से</Option>
                                <Option value="walk_in">सीधे कार्यालय आकर</Option>
                                <Option value="website">वेबसाइट द्वारा</Option>
                                <Option value="app">एप्लिकेशन द्वारा</Option>
                                <Option value="phone_call">फोन कॉल द्वारा</Option>
                                <Option value="event">कार्यक्रम में</Option>
                                <Option value="other">अन्य</Option>
                              </Select>
                            </Item>
                          </Col>
                          {refSource === 'member' && (
                            <Col xs={24} sm={12} lg={8}>
                              <Item label="संदर्भ सदस्य (Referrer)" name="ref_member_id">
                                <Select
                                  showSearch
                                  labelInValue
                                  placeholder="नाम या मोबाइल टाइप करें"
                                  filterOption={false}
                                  onSearch={searchRefMember}
                                  loading={refMemberSearching}
                                  notFoundContent={refMemberSearching ? <Spin size="small" /> : 'कोई सदस्य नहीं मिला'}
                                  allowClear
                                  options={refMemberOptions}
                                />
                              </Item>
                            </Col>
                          )}
                          <Col xs={24} sm={12} lg={refSource === 'member' ? 10 : 18}>
                            <Item label="नोट (वैकल्पिक)" name="ref_note">
                              <Input placeholder="कोई अतिरिक्त जानकारी..." />
                            </Item>
                          </Col>
                        </Row>
                      </Col>

                      {/* Address and Additional Information Sections */}
                      <Descriptions bordered column={{ xs: 1, sm: 2, lg: 4 }} className="ModalTable">
                        <Descriptions.Item label="Permanent Address"> 
                          <Checkbox
                            checked={selectedAddressSection === 'permanentAddress'}
                            onChange={() => handleAddressCheckboxChange('permanentAddress')}
                          />
                        </Descriptions.Item>
                        <Descriptions.Item label="Temporary Address">
                          <Checkbox
                            checked={selectedAddressSection === 'temporaryAddress'}
                            onChange={() => handleAddressCheckboxChange('temporaryAddress')}
                          />
                        </Descriptions.Item>
                        <Descriptions.Item label="Social Media Link">
                          <Checkbox
                            checked={selectedAddressSection === 'socialLink'}
                            onChange={() => handleAddressCheckboxChange('socialLink')}
                          />
                        </Descriptions.Item>
                        <Descriptions.Item label="Upload File/document">
                          <Checkbox
                            checked={selectedAddressSection === 'uploadFile'}
                            onChange={() => handleAddressCheckboxChange('uploadFile')}
                          />
                        </Descriptions.Item>
                      </Descriptions>

                             {selectedAddressSection === 'permanentAddress' && (

                        <>
                          <Col xs={24} sm={24} lg={24}>
                            <Row gutter={[0, 0]}>
                              <Col Col xs={24} sm={24} lg={24}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #f0f0f0' }}>Permanent Address</div>
                              </Col>
                            </Row>
                            <Row gutter={[8, 0]} style={{ rowGap: 0 }} className="compact-address-row">

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="House No.">
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_address_en", e.target.value, "per_address_hn", true)
                                  }
                                    value={permanentAddress.per_address_en} placeholder="Enter Street/Building/House No." prefix={<HomeOutlined />} />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label={
                                  <span>Village {permanentAddress.per_village_id && <span style={{ color: '#52c41a', fontSize: 10, fontWeight: 700 }}>✓ Master</span>}</span>
                                }>
                                  <AutoComplete
                                    placeholder="Village name (type freely or search master)..."
                                    onChange={(val) => {
                                      if (villageJustSelectedRef.current) {
                                        villageJustSelectedRef.current = false;
                                        return;
                                      }
                                      if (val) searchVillage(val);
                                      else setVillageOptions([]);
                                      setPermanentAddress(prev => ({ ...prev, per_village_en: val || '', per_village_id: null }));
                                    }}
                                    onSelect={handleVillageSelect}
                                    onClear={() => setPermanentAddress(prev => ({ ...prev, per_village_id: null, per_village_en: '' }))}
                                    filterOption={false}
                                    notFoundContent={villageSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search or enter manually</span>}
                                    allowClear
                                    value={permanentAddress.per_village_en || undefined}
                                    style={{ width: '100%' }}
                                    options={villageOptions}
                                    dropdownStyle={{ minWidth: 320 }}
                                  />
                                  {permanentAddress.per_village_en && !permanentAddress.per_village_id && (
                                    <div style={{ fontSize: 10, color: '#faad14', marginTop: 2 }}>⚠ Not linked to master</div>
                                  )}
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="Post"  >
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_post_en", e.target.value, "per_post_hn", true)
                                  }
                                    value={permanentAddress.per_post_en} placeholder="Enter Post" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="Tehsil" >
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_tahsil_en", e.target.value, "per_tahsil_hn", true)
                                  }
                                    value={permanentAddress.per_tahsil_en} placeholder="Enter Tahsil" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="Pin Code"  >
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_pin_code_en", e.target.value, "per_pin_code_hn", false)
                                  }
                                    value={permanentAddress.per_pin_code_en} placeholder="Enter Pin Code" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="District"  >
                                  <AutoComplete placeholder="Enter District"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("per_district_en", value, "per_district_hn", true)}
                                    value={permanentAddress.per_district_en}
                                    onChange={(value) => handleChangeSuggestion(value, "per_district_en")}
                                    onSearch={(text) => getPanelValue(text, "per_district_en", "sn_user_address")}
                                  />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="State"  >
                                  <AutoComplete placeholder="Enter State" defaultValue="Rajasthan"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("per_state_en", value, "per_state_hn", true)}
                                    value={permanentAddress.per_state_en}
                                    onChange={(value) => handleChangeSuggestion(value, "per_state_en")}
                                    onSearch={(text) => getPanelValue(text, "per_state_en", "sn_user_address")}
                                  />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="Country" >
                                  <AutoComplete placeholder="Enter Country" defaultValue="India"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("per_country_en", value, "per_country_hn", true)}
                                    value={permanentAddress.per_country_en}
                                    onChange={(value) => handleChangeSuggestion(value, "per_country_en")}
                                    onSearch={(text) => getPanelValue(text, "per_country_en", "sn_user_address")}
                                  />
                                </Item>
                              </Col>

                            </Row>

                            {/* स्थाई पता */}

                            <Row gutter={[0, 0]}>
                              <Col Col xs={24} sm={24} lg={24}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #f0f0f0', marginTop: 4 }}>स्थाई पता</div>
                              </Col>
                            </Row>
                            <Row gutter={[8, 0]} className="compact-address-row">

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="गली/बास/मकान नंबर."  >
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_address_hn", e.target.value)
                                  }
                                    value={permanentAddress.per_address_hn} placeholder="गली/बास/मकान नंबर दर्ज करें" prefix={<HomeOutlined />} />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="गाँव/कस्बा/वार्ड" >
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_village_hn", e.target.value)
                                  }
                                    value={permanentAddress.per_village_hn} placeholder="गाँव/कस्बा/वार्ड दर्ज करें" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="पोस्ट" >
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_post_hn", e.target.value)
                                  }
                                    value={permanentAddress.per_post_hn} placeholder="पोस्ट दर्ज करें" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="तहसील" >
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_tahsil_hn", e.target.value)
                                  }
                                    value={permanentAddress.per_tahsil_hn} placeholder="तहसील दर्ज करें" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="पिनकोड" >
                                  <Input onChange={(e) =>
                                    handlePermanentAddressChange("per_pin_code_hn", e.target.value)
                                  }
                                    value={permanentAddress.per_pin_code_hn} placeholder="पिनकोड दर्ज करें" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="जिला" >
                                  <AutoComplete placeholder="जिला दर्ज करें"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("per_district_hn", value, "per_district_hn", false)}
                                    value={permanentAddress.per_district_hn}
                                    onChange={(value) => handleChangeSuggestion(value, "per_district_hn")}
                                    onSearch={(text) => getPanelValue(text, "per_district_hn", "sn_user_address")}
                                  />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="राज्य" >
                                  <AutoComplete placeholder="राज्य दर्ज करें" defaultValue="राजस्थान"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("per_state_hn", value, "per_state_hn", false)}
                                    value={permanentAddress.per_state_hn}
                                    onChange={(value) => handleChangeSuggestion(value, "per_state_hn")}
                                    onSearch={(text) => getPanelValue(text, "per_state_hn", "sn_user_address")}
                                  />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="देश" >
                                  <AutoComplete placeholder="देश दर्ज करें"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("per_country_hn", value, "per_country_hn", false)}
                                    value={permanentAddress.per_country_hn}
                                    onChange={(value) => handleChangeSuggestion(value, "per_country_hn")}
                                    onSearch={(text) => getPanelValue(text, "per_country_hn", "sn_user_address")}
                                  />
                                </Item>
                              </Col>

                            </Row>
                          </Col>


                        </>
                      )}



                      {selectedAddressSection === 'temporaryAddress' && (
                        <>

                          <Col xs={24} sm={24} lg={24}>
                            <Row gutter={[0, 0]}>
                              <Col Col xs={24} sm={24} lg={12}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #f0f0f0' }}>Temporary Address</div>
                              </Col>
                              <Col xs={24} sm={12} lg={12} style={{ textAlign: 'right' }}>
                                <Checkbox style={{ fontSize: '12px' }} onChange={handleSameAsPermanentChange}>Same as PA</Checkbox>
                              </Col>
                            </Row>
                            <Row gutter={[8, 0]} className="compact-address-row">

                              <Col xs={24} sm={12} lg={4}>
                                <Item label="House No." >
                                  <Input onChange={(e) =>
                                    handleTemporaryAddressChange("tem_address_en", e.target.value, "tem_address_hn", true)
                                  }
                                    value={temporaryAddress.tem_address_en} placeholder="House No/Flat No/Building Name" prefix={<HomeOutlined />} />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={4}>
                                <Item label="Village/Town/Ward" >
                                  <Input onChange={(e) =>
                                    handleTemporaryAddressChange("tem_street_en", e.target.value, "tem_street_hn", true)
                                  }
                                    value={temporaryAddress.tem_street_en} placeholder="Enter Town/City/Ward" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={4}>
                                <Item label="City" >
                                  <Input onChange={(e) =>
                                    handleTemporaryAddressChange("tem_city_en", e.target.value, "tem_city_hn", true)
                                  }
                                    value={temporaryAddress.tem_city_en} placeholder="Enter City" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="Pin Code" >
                                  <Input onChange={(e) =>
                                    handleTemporaryAddressChange("tem_pin_code_en", e.target.value, "tem_pin_code_hn", false)
                                  }
                                    value={temporaryAddress.tem_pin_code_en} placeholder="Enter Pin Code" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="District" >
                                  <AutoComplete placeholder="District"

                                    options={optionSuggestion}
                                    onSelect={(value) => handleTemporaryAddressChange("tem_district_en", value, "tem_district_hn", true)}
                                    value={temporaryAddress.tem_district_en}
                                    onChange={(value) => handleChangeSuggestionTemp(value, "tem_district_en")}
                                    onSearch={(text) => getPanelValue(text, "tem_district_en", "sn_user_address")}
                                  />


                                </Item>
                              </Col>


                              <Col xs={24} sm={12} lg={3}>
                                <Item label="State" >
                                  <AutoComplete placeholder="State"

                                    options={optionSuggestion}
                                    onSelect={(value) => handleTemporaryAddressChange("tem_state_en", value, "tem_state_hn", true)}
                                    value={temporaryAddress.tem_state_en}
                                    onChange={(value) => handleChangeSuggestionTemp(value, "tem_state_en")}
                                    onSearch={(text) => getPanelValue(text, "tem_state_en", "sn_user_address")}
                                  />

                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="Country" >

                                  <AutoComplete placeholder="Country"

                                    options={optionSuggestion}
                                    onSelect={(value) => handleTemporaryAddressChange("tem_country_en", value, "tem_country_hn", true)}
                                    value={temporaryAddress.tem_country_en}
                                    onChange={(value) => handleChangeSuggestionTemp(value, "tem_country_en")}
                                    onSearch={(text) => getPanelValue(text, "tem_country_en", "sn_user_address")}
                                  />

                                </Item>
                              </Col>

                            </Row>

                            <Row gutter={[0, 0]}>
                              <Col Col xs={24} sm={24} lg={24}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #f0f0f0', marginTop: 4 }}>अस्थाई पता</div>
                              </Col>
                            </Row>

                            <Row gutter={[8, 0]} className="compact-address-row">

                              <Col xs={24} sm={12} lg={4}>
                                <Item label="मकान/फ्लैट" >
                                  <Input onChange={(e) =>
                                    handleTemporaryAddressChange("tem_address_hn", e.target.value)
                                  }
                                    value={temporaryAddress.tem_address_hn} placeholder="मकान/फ्लैट" prefix={<HomeOutlined />} />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={4}>
                                <Item label="गाँव/कस्बा/वार्ड" >
                                  <Input onChange={(e) =>
                                    handleTemporaryAddressChange("tem_street_hn", e.target.value)
                                  }
                                    value={temporaryAddress.tem_street_hn} placeholder="नगर/कस्बा/वार्ड दर्ज करें" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={4}>
                                <Item label="सिटी" >
                                  <Input onChange={(e) =>
                                    handleTemporaryAddressChange("tem_city_hn", e.target.value)
                                  }
                                    value={temporaryAddress.tem_city_hn} placeholder="सिटी दर्ज करें" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="पिनकोड" >
                                  <Input onChange={(e) =>
                                    handleTemporaryAddressChange("tem_pin_code_hn", e.target.value)
                                  }
                                    value={temporaryAddress.tem_pin_code_hn} placeholder="पिनकोड दर्ज करें" />
                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="जिला" >

                                  <AutoComplete placeholder="जिला दर्ज करें"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("tem_district_hn", value, "tem_district_hn", false)}
                                    value={temporaryAddress.tem_district_hn}
                                    onChange={(value) => handleChangeSuggestionTemp(value, "tem_district_hn")}
                                    onSearch={(text) => getPanelValue(text, "tem_district_hn", "sn_user_address")}
                                  />


                                </Item>
                              </Col>


                              <Col xs={24} sm={12} lg={3}>
                                <Item label="राज्य" >

                                  <AutoComplete placeholder="राज्य दर्ज करें"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("tem_state_hn", value, "tem_state_hn", false)}
                                    value={temporaryAddress.tem_state_hn}
                                    onChange={(value) => handleChangeSuggestionTemp(value, "tem_state_hn")}
                                    onSearch={(text) => getPanelValue(text, "tem_state_hn", "sn_user_address")}
                                  />


                                </Item>
                              </Col>

                              <Col xs={24} sm={12} lg={3}>
                                <Item label="देश"  >

                                  <AutoComplete placeholder="देश राज्य करें"
                                    options={optionSuggestion}
                                    onSelect={(value) => handlePermanentAddressChange("tem_country_hn", value, "tem_country_hn", false)}
                                    value={temporaryAddress.tem_country_hn}
                                    onChange={(value) => handleChangeSuggestionTemp(value, "tem_country_hn")}
                                    onSearch={(text) => getPanelValue(text, "tem_country_hn", "sn_user_address")}
                                  />

                                </Item>
                              </Col>

                            </Row>
                          </Col>

                        </>
                      )}



                      {selectedAddressSection === 'socialLink' && (
                        <>

                          <Col xs={24} sm={24} lg={24}>
                            <Row gutter={[0, 0]}>
                              <Col Col xs={24} sm={24} lg={12}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #f0f0f0' }}>Social Media Link</div>
                              </Col>
                            </Row>

                            <Row gutter={[8, 0]}>
                              <Col xs={24} sm={12} lg={8}>
                                <Item label="Facebook Profile URL" >
                                  <Input onChange={(e) =>
                                    handleSocialMediaChange("facebook_url", e.target.value)
                                  }
                                    value={socialMediaLinks.facebook_url} placeholder="Facebook Profile URL" prefix={<FacebookOutlined />} />
                                </Item>
                              </Col>
                              <Col xs={24} sm={12} lg={8}>
                                <Item label="Instagram Profile URL" >
                                  <Input onChange={(e) =>
                                    handleSocialMediaChange("instagram_url", e.target.value)
                                  }
                                    value={socialMediaLinks.instagram_url} placeholder="Instagram Profile URL" prefix={<InstagramOutlined />} />
                                </Item>
                              </Col>
                              <Col xs={24} sm={12} lg={8}>
                                <Item label="Twitter Profile URL" >
                                  <Input onChange={(e) =>
                                    handleSocialMediaChange("twitter_url", e.target.value)
                                  }
                                    value={socialMediaLinks.twitter_url} placeholder="Twitter Profile URL" prefix={<TwitterOutlined />} />
                                </Item>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      )}

                      {selectedAddressSection === 'uploadFile' && (
                        <>
                          <Col xs={24} sm={24} lg={24}>
                            <Row gutter={[0, 0]}>
                              <Col Col xs={24} sm={24} lg={12}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #f0f0f0' }}>Upload File/document</div>
                              </Col>
                            </Row>

                            <Row gutter={[8, 0]}>
                              <Col xs={24} sm={12} lg={24}>
                                <Upload

                                  beforeUpload={beforeUpload}
                                  multiple
                                  fileList={fileList.map(file => ({
                                    uid: file.name,
                                    name: file.name,
                                    status: 'done',
                                  }))}
                                  onRemove={(file) => {
                                    setFileList(prevState => prevState.filter(item => item.name !== file.name));
                                  }}
                                >
                                  <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                </Upload>
                                <br />
                                <Space size={20} direction="vertical"></Space>
                                {/* <Image.PreviewGroup
                                  style={{ marginTop: "10px" }}
                                  preview={{
                                    onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                                  }}
                                >
                                  <Space size="middle" wrap>
                                    {multiDocument.map((item, i) => {
                                      const isPdf = item.endsWith('.pdf');
                                      if (isPdf) {
                                        return (
                                          <div key={i} style={{ width: 75, height: 75, position: 'relative' }}>
                                            <a
                                              href={`${baseUrl}/${item}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, zIndex: 10 }}
                                            >
                                              <img
                                                src={PdfImage}
                                                alt="PDF thumbnail"
                                                style={{ width: '100%', height: '100%' }}
                                              />
                                            </a>
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <Image
                                            key={i}
                                            width={75}
                                            src={`${baseUrl}/${item}`}
                                            style={{ marginBottom: 8 }}
                                          />
                                        );
                                      }
                                    })}
                                  </Space>
                                </Image.PreviewGroup> */}


                                <Image.PreviewGroup
                                  preview={{
                                    onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                                  }}
                                >
                                  {multiDocument.map((item, i) => {
                                    const isPdf = item.endsWith('.pdf');
                                    const isDoc = item.endsWith('.doc') || item.endsWith('.docx');
                                    const isXlsx = item.endsWith('.xlsx') || item.endsWith('.xls');

                                    const handleDeleteImage = (imagePath) => {
                                      // Call the delete API and handle response
                                      deleteImage(userId, imagePath);
                                    };

                                    const getFileThumbnail = () => {
                                      if (isPdf) {
                                        return PdfImage; // Use a suitable PDF thumbnail image
                                      } else if (isDoc) {
                                        return DocImage; // Use a suitable DOC thumbnail image
                                      } else if (isXlsx) {
                                        return XlsxImage; // Use a suitable XLSX thumbnail image
                                      }
                                      return null; // In case of other file types, you can return null or a default image
                                    };

                                    const fileThumbnail = getFileThumbnail();

                                    return (
                                      <div key={i} style={{ display: 'inline-block', margin: '5px', position: 'relative' }}>
                                        <Popconfirm
                                          title="Are you sure you want to delete this file?"
                                          onConfirm={() => handleDeleteImage(item)}
                                          okText="Yes"
                                          cancelText="No"
                                        >
                                          <DeleteOutlined
                                            style={{
                                              color: 'red',
                                              fontSize: '16px',
                                              position: 'absolute',
                                              top: -18,
                                              right: 0,
                                              cursor: 'pointer'
                                            }}
                                          />
                                        </Popconfirm>

                                        {fileThumbnail ? (
                                          <div style={{ width: 75, height: 75, position: 'relative' }}>
                                            <a
                                              href={item}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, zIndex: 10 }}
                                            >
                                              <img
                                                src={fileThumbnail}
                                                alt={`${item} thumbnail`}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                              />
                                            </a>
                                          </div>
                                        ) : (
                                          <Image
                                            width={75}
                                            height={75}
                                            src={item}
                                            style={{
                                              objectFit: 'cover',
                                              verticalAlign: 'middle',  // Ensures the image aligns vertically in the middle
                                              display: 'block'         // Removes any potential inline space that might affect alignment
                                            }}
                                          />

                                        )}
                                      </div>
                                    );
                                  })}

                                </Image.PreviewGroup>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      )}
                    </Row>

                    {/* Save Button */}
                    <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 20, display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24 }}>
                      <Button
                        type="primary"
                        icon={saving ? null : <SaveOutlined />}
                        loading={saving}
                        onClick={() => form.submit()}
                        style={{ background: '#7a0000', borderColor: '#7a0000', borderRadius: 8 }}
                      >
                        {saving ? 'Saving...' : (mode === 'create' ? 'Create Member' : 'Update Details')}
                      </Button>
                    </div>
                  </Form>
              </Col>
            </Row>
          </TabPane>

          {/* Other tabs - only show for existing users */}
          {userCheckId && mode !== 'create' && (
            <>
              <TabPane tab="Occupation/Business details" key="2">
                <OccupationDetails user_id={userCheckId} />
              </TabPane>
              <TabPane tab="Family Details" key="3">
                <FamilyDetails user_id={userCheckId} />
              </TabPane>
              <TabPane tab="Social Status" key="4">
                <SocialStatus user_id={userCheckId} />
              </TabPane>
            </>
          )}
        </Tabs>
      </div>
    </>
  );
};

export default AddUserDetailsModel;